<template>
  <div id="rbacUploadJson" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content first-modal-content">
        <div class="modal-header modal-bgcolor">
          <div class="modal-title">Upload JSON file</div>
        </div>
        <div class="modal-body">
          <div class="container-fluid row">
            <div class="col-sm-4 attachment-text">
              <span class="cursor"> Upload File:</span>
            </div>
            <div class="col-sm-8">
              <div class="upload-demo">
                <input type="file" ref="file" :name="uploadFieldName" id="custom-file" @change="filesChange"/>
                <label for="custom-file">
                  <div class="cursor-pointer">
                    <a class="btn emergo-white-button"
                      >Click to upload</a
                    >
                    <div class="notify_message">
                      File type allowed: json
                    </div>
                  </div>
                </label>

                <!-- <el-upload
                  class="upload-demo"
                  action
                  :name="uploadFieldName"
                  accept=".json"
                  :multiple=false
                  :on-change="filesChange"
                  :file-list="uploadedFiles"
                  :auto-upload=false
                >
                  <button class="btn emergo-white-button"
                    >Click to upload</button
                  >
                  <div class="notify_message">
                    File type allowed: json
                  </div>
                </el-upload> -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-modal-footer cancel"
            style="float: left;background: #fff;"
            data-dismiss="modal"
            @click="cancelPermissions"
          >
            <i class="fa fa-times-circle"></i> No, cancel
          </button>
          <button
            type="button"
            class="btn btn-modal-footer"
            style="float: right;"
            @click="uploadFile"
            :disabled="Object.keys(roleList).length == 0"
          >Next</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import axios from 'axios';
import EventBus from '../../utils/event-bus';

export default {
  components: {},
  props: ['type', 'selectedRoleIdToUpload'],
  data() {
    return {
      uploadedFiles: [],
      uploadFieldName: 'file',
      fileName: '',
      roleList: {},
    };
  },
  watch: {},
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },

    isValidJSONString(data) {
      try {
        JSON.parse(JSON.stringify(data));
      } catch (e) {
        return false;
      }
      return true;
    },
    validateFile(file) {
      return file.type === 'application/json';
      /* if (file.type !== 'application/json') {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'File type mismatch',
          text: 'Please upload appropriate JSON file',
          group: 'custom-notification',
        });
        return false;
      }
      return true; */
    },
    async filesChange() {
      const fileList = this.$refs.file.files;
      this.roleList = {};
      const file = fileList[fileList.length - 1];
      if (this.validateFile(file)) {
        await axios.get(URL.createObjectURL(file)).then((data) => {
          if (this.isValidJSONString(data.data)) {
            if (this.type === 'existing_role_template') {
              if (this.selectedRoleIdToUpload === data.data.role_id) {
                this.roleList = data.data;
              } else {
                this.roleList = {};
                this.uploadedFiles = [];
                this.fileName = '';
                this.clearNotifications();
                this.$notify({
                  type: 'error',
                  title: 'Invalid File',
                  text: 'Please upload appropriate file against Role',
                  group: 'custom-notification',
                });
              }
            } else {
              this.roleList = data.data;
            }
          } else {
            this.clearNotifications();
            this.$notify({
              type: 'error',
              title: 'File type mismatch',
              text: 'Please upload appropriate JSON file',
              group: 'custom-notification',
            });
          }
        });
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'File type mismatch',
          text: 'Please upload appropriate JSON file',
          group: 'custom-notification',
        });
      }
    },
    uploadFile() {
      this.$emit('openAddRolePopup', this.roleList);
      $('#rbacUploadJson').modal('hide');
    },
    cancelPermissions() {
      this.roleList = {};
      this.uploadedFiles = [];
      this.fileName = '';
      this.uploadFieldName = 'file';
      $('#rbacUploadJson').modal('hide');
    },
  },
  mounted() {
    EventBus.$on('clearUploadedJsonFile', () => {
      this.roleList = {};
      this.uploadedFiles = [];
      this.fileName = '';
      $('#rbacUploadJson').modal('hide');
    });
    $('#rbacUploadJson').on('shown.bs.modal');
  },
};
</script>
<style scoped lang="scss">
.upload-demo {
	input[type="file"] {
		display: none;
	}
}
.el-upload__input {
	display: none;
	background-color: #dcffda;
	padding: 0px;
	border-radius: 0px;
	margin-top: 0px;
	margin-bottom: 0px;
}
.notify_message {
  font-size: $font-12;
  line-height: 14px;
  padding-top: 6px;
}
.custom-el-upload-list__item-name {
  color: #409eff;
  cursor: pointer;
  text-align: left;
}
.custom-el-upload-list__item {
  background-color: #f5f7fa;
}
.custom-el-icon-close {
  background-color: transparent !important;
  color: #d8212b !important;
  display: inline-block !important;
}
::v-deep {
	.excel-popover {
		text-align: left;
		left: 2%;
	}
}
::v-deep {
	.el-upload-list__item-name {
		.download-icon {
			font-weight: 700;
			color: $primary;
		}
	}
}
::v-deep {
  .el-upload {
    text-align: left;
  }
}
.attachment-text {
  margin-bottom: 10px;
}
::v-deep {
	.upload-demo {
		ul {
			&.el-upload-list {
				display: none;
			}
		}
	}
}
@media screen and (min-width: 768px) {
  .attachment-text {
    text-align: right;
    margin: 0;
  }
  ::v-deep {
    .excel-popover {
      left: 18%;
    }
  }
}
@media screen and (min-width: 992px) {
  ::v-deep {
    .excel-popover {
      left: 45%;
    }
  }
}
</style>
